import {useEffect} from "react";
import {useUser} from "UserProvider";
import TermsStorage from "./TermsStorage";
import {submitTermsAcceptance, verifyTermsAcceptanceAccount} from "./TermsAcceptanceApi";
import {replayTermsAcceptance} from "./termsAcceptanceReplay";

/**
 * Thin React adapter between the cached account candidate and the React-free replay coordinator.
 * The coordinator verifies that candidate against restored Firebase auth before ownership can move.
 *
 * It watches the account ID rather than only a logged-in boolean, so A→logout→B cannot reuse A's
 * browser claim. The store subscription is the same-tab trigger the browser's `storage` event cannot
 * provide: accepting after the initial login check reaches the API immediately without a reload.
 */
export function useTermsAcceptanceReplay(): void {
	const [user] = useUser();
	const accountId = user.isLoggedIn ? user.id : null;

	useEffect(() => {
		const replay = () => {
			void replayTermsAcceptance(accountId, submitTermsAcceptance, verifyTermsAcceptanceAccount);
		};
		replay();
		return TermsStorage.subscribe(replay);
	}, [accountId]);
}
